import React, { useEffect, useRef } from "react";

interface IProps {
    children: React.ReactNode;
    fecharModal: () => void;
    zIndex?: number;
    aoMontarModal?: () => void;
    impedirFechamentoAoClicarFora?: boolean;
    modalStyle?: React.CSSProperties;
}

const ModalWinSet = ({ children, fecharModal, zIndex = 1000, aoMontarModal, impedirFechamentoAoClicarFora, modalStyle }: IProps) => {
    const overlayRef = useRef<HTMLDivElement>(null);

    const handleFecharModal = () => {
        fecharModal();
    };

    const handleClickOutside = (event: any) => {
        if (impedirFechamentoAoClicarFora) return;
        if (overlayRef.current && event.target === overlayRef.current) {
            handleFecharModal();
        }
    };

    const handleTouchMove = (event: React.TouchEvent) => {
        // Prevenir scroll no overlay
        event.preventDefault();
    };

    const buscarPreferencias = () => {
        const preferencias = localStorage.getItem("preferencias");
        if (preferencias) {
            return JSON.parse(preferencias);
        }
        return {};
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                fecharModal();
            }
        };

        // Prevenir scroll no mobile - salvar posição atual
        const scrollY = window.scrollY;
        
        if (aoMontarModal) {
            aoMontarModal();
        }
        
        // Bloquear scroll - múltiplas técnicas para mobile
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
        document.documentElement.style.overflow = "hidden";
        
        // Prevenir eventos de touch que causam scroll
        const preventTouchMove = (e: TouchEvent) => {
            e.preventDefault();
        };
        
        document.addEventListener("touchmove", preventTouchMove, { passive: false });
        window.addEventListener("keydown", handleKeyDown);

        return () => {
            // Restaurar scroll e posição
            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.width = "";
            document.documentElement.style.overflow = "";
            
            window.scrollTo(0, scrollY);
            
            document.removeEventListener("touchmove", preventTouchMove);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [aoMontarModal, fecharModal]);

    return (
        <React.Fragment>
            <div
                ref={overlayRef}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    background: "rgba(0, 0, 0, 0.5)",
                    zIndex: zIndex,
                    overflow: "hidden",
                    touchAction: "none",
                }}
                onClick={handleClickOutside}
                onTouchMove={handleTouchMove}
                className="d-flex justify-content-center align-items-center overlay"
            >
                <div
                    className='d-flex flex-column justify-content-start bg-white shadow rounded'
                    style={{
                        position: "absolute",
                        minWidth: "200px",
                        minHeight: "100px",
                        zIndex: zIndex + 1,
                        overflow: "hidden",
                        maxHeight: "calc(100% - 32px)",
                        maxWidth: "calc(100vw - 48px)",
                        ...modalStyle,
                    }}
                >
                    { /* @ts-ignore */  }
                    <div className='w-100' style={{ background: buscarPreferencias().corPrincipal, height: "1rem" }} />
                    <div className='w-100 barra_de_rolagem_estilizada' style={{ height: 'calc(100% - 1rem)', overflow: 'auto' }}>
                        { children }
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ModalWinSet;

